import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberShort'
})
export class NumberShortPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) return '';
    if (value < 1000) return value.toString();

    if (value >= 1e7) {
      return Math.floor(value / 1e7) + 'Cr+';
    }

    if (value >= 1e5) {
      return Math.floor(value / 1e5) + 'L+';
    }

    if (value >= 1e3) {
      return Math.floor(value / 1e3) + 'K+';
    }

    return value.toString();
  }
}
